var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-stripe" },
    [
      _c("div", { staticClass: "emd-tabbar jsTabbar _bordered" }, [
        _c("ul", { staticClass: "emd-tabbar__list" }, [
          _c("li", { staticClass: "emd-tabbar__item" }, [
            _c(
              "a",
              {
                staticClass: "emd-tabbar__link",
                class: { _active: _vm.tabActive === "info" },
                on: {
                  click: function ($event) {
                    return _vm.changeTab("info")
                  },
                },
              },
              [
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.$t("customer.detail.tab-info"))),
                ]),
              ]
            ),
          ]),
          _vm.permissionIsEnabled("order:search")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "orders" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("orders")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(_vm._s(_vm.$t("customer.detail.tab-orders"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.componentIsEnabled("sidemenu", "subscriptions") &&
          _vm.permissionIsEnabled("subscription:search")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "subscriptions" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("subscriptions")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer.detail.tab-subscriptions"))
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.componentIsEnabled("sidemenu", "invoices") &&
          _vm.permissionIsEnabled("invoice:search")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "invoices" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("invoices")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(_vm._s(_vm.$t("customer.detail.tab-invoices"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.permissionIsEnabled("charge:search")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "charges" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("charges")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(_vm._s(_vm.$t("customer.detail.tab-charges"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.permissionIsEnabled("customer.cards:get")
            ? _c("li", { staticClass: "emd-tabbar__item" }, [
                _c(
                  "a",
                  {
                    staticClass: "emd-tabbar__link",
                    class: { _active: _vm.tabActive === "cards" },
                    on: {
                      click: function ($event) {
                        return _vm.changeTab("cards")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "emd-text" }, [
                      _vm._v(_vm._s(_vm.$t("customer.detail.tab-cards"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.tabActive === "info" ? _c("customer-info") : _vm._e(),
      _vm.tabActive === "orders" && _vm.permissionIsEnabled("order:search")
        ? _c("customer-orders")
        : _vm._e(),
      _vm.tabActive === "subscriptions" &&
      _vm.componentIsEnabled("sidemenu", "subscriptions") &&
      _vm.permissionIsEnabled("subscription:search")
        ? _c("customer-subscriptions")
        : _vm._e(),
      _vm.tabActive === "invoices" &&
      _vm.componentIsEnabled("sidemenu", "invoices") &&
      _vm.permissionIsEnabled("invoice:search")
        ? _c("customer-invoices")
        : _vm._e(),
      _vm.tabActive === "charges" && _vm.permissionIsEnabled("charge:search")
        ? _c("customer-charges")
        : _vm._e(),
      _vm.tabActive === "cards" && _vm.permissionIsEnabled("customer.cards:get")
        ? _c("customer-cards")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }